export default {
  styleOverrides: {
    root: {
      backgroundColor: '#f2f4fa',
      color: 'rgba(0, 0, 0, 0.55)'
    }
  }
};
